// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
import React from 'react'
import { WithErrorBoundary } from '../common/ErrorBoundary'

const GastosGestoria = WithErrorBoundary(
  'GastosGestoria',
  'Error en GastosGestoria',
  React.lazy(() => import('./GastosGestoria')),
)


export default {
  path: '/gastos-gestoria',
  name: 'Gastos gestoria',
  childRoutes: [
    { path: '', name: 'Gastos gestoria', component: GastosGestoria, isIndex: true },
  ],
};
